import { gql, useQuery } from "@apollo/client";
import { TeacherTier } from "./teacherTiers.ts";

const GetTeacherAssignmentCapOverviewQuery = gql`
  query getTeacherAssignmentCapOverview(
    $teacherId: String!
    $upcomingWeeks: Int!
  ) {
    getTeacherAssignmentCapOverview(
      teacherId: $teacherId
      upcomingWeeks: $upcomingWeeks
    ) {
      finalScore
      tier
      maxPercentOfWeeklyAvailability
      weeks {
        weekStartUtc
        weekEndUtc
        offeredSlots
        assignedClassRooms
        maxAssignableClassRooms
        hasBeenReached
      }
    }
  }
`;

export type TeacherAssignmentCapWeek = {
  weekStartUtc: string;
  weekEndUtc: string;
  offeredSlots: number;
  assignedClassRooms: number;
  maxAssignableClassRooms: number;
  hasBeenReached: boolean;
};

export type TeacherAssignmentCapOverview = {
  finalScore: number;
  tier: TeacherTier;
  maxPercentOfWeeklyAvailability: number;
  weeks: TeacherAssignmentCapWeek[];
};

type QueryResult = {
  getTeacherAssignmentCapOverview: TeacherAssignmentCapOverview;
};

export const ASSIGNMENT_CAP_UPCOMING_WEEKS = 4;

export function useTeacherAssignmentCapOverview(teacherId: string) {
  const { data, loading } = useQuery<QueryResult>(
    GetTeacherAssignmentCapOverviewQuery,
    {
      variables: { teacherId, upcomingWeeks: ASSIGNMENT_CAP_UPCOMING_WEEKS },
      fetchPolicy: "cache-and-network",
    },
  );

  return {
    overview: data?.getTeacherAssignmentCapOverview ?? null,
    loading: loading && !data,
  };
}
